/**
 * InfoIcon component renders an SVG icon with customizable color, size, and additional class names.
 * It also supports an optional click handler.
 *
 * @param {Object} props - The properties object.
 * @param {string} [props.color] - The color of the icon. Defaults to "#1D31A5".
 * @param {number|string} [props.size] - The size of the icon. Defaults to "20".
 * @param {string} [props.className] - Additional class names for the SVG element.
 * @param {function} [props.onClick] - Optional click handler function.
 *
 * @returns {JSX.Element} The rendered SVG icon.
 */
const InfoIcon = ({ color, size, className, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? "20"}
      height={size ?? "20"}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      onClick={handleClick}
    >
      <path
        d="M9.375 9.375L9.40957 9.35771C9.88717 9.11891 10.4249 9.55029 10.2954 10.0683L9.70458 12.4317C9.57507 12.9497 10.1128 13.3811 10.5904 13.1423L10.625 13.125M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 6.875H10.0063V6.88125H10V6.875Z"
        stroke={color ?? "#1D31A5"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InfoIcon;
